'use strict'

import React from 'react';
import uuid from 'uuid';

import AreaForm from '../components/AreaForm.jsx'
import ProjectMenu from '../components/ProjectMenu.jsx';
import Layout from '../Layout.jsx';
import {Change} from '../Change.jsx';

import sendCommand from '../../app/utils/sendCommand.js';

import formDefinition from './changeControlApproachFormDefinition.js';
import Translations from '../../app/utils/translations.js';

let translations=new Translations([
  require('./labels/english.js'),
  require('./labels/norwegian.js')
]);

export class ChangeControlApproach extends React.Component {
  constructor(props) {
    super(props);
    var selected=0;
    if (typeof window!=="undefined" && window.location.hash.length>0) {
      formDefinition.forEach((area,index) =>{
        if (area.name===window.location.hash.slice(1)) {
          selected=index;
        }
      })
    }
    this.state={
      approach: Object.assign({},this.props.project.changeControlApproach,{
        id: this.props.project.changeControlApproach!==undefined ? "savedApproach" : undefined,
        _progress: "changeControlApproach"
      }),
      selected: selected
    };
  }

  summary(area,details) {
    let labels=translations.getTranslation(this.props);
    switch (area) {
      case "issueRegister":
        return (
          <Change {...this.props} onDetails={details.onDetails}/>
        );
      default:
       return (
         <i>{labels[area].description}</i>
       );
    }
  }

  updateApproach(approach) {
    let strippedApproach=Object.assign({},approach,{_progress:undefined,id:undefined});
    var command={type:"updateChangeControlApproach", approach:strippedApproach};
    if (this.props.project.isProduct===true) {
      command=Object.assign({},command,{
        product:{id:this.props.project.id}
      });
    } else if (this.props.project.isProgramme===true) {
      command=Object.assign({},command,{
        programme:{id:this.props.project.id}
      });
    } else if (this.props.project.isRelease===true) {
      command=Object.assign({},command,{
        release:{id:this.props.project.id}
      });
    } else {
      command=Object.assign({},command,{
        project:{id:this.props.project.id}
      });
    }
    sendCommand(command)
      .then(response=>{
        this.setState({approach: Object.assign({},this.state.approach, response.approach, {id:"saved"})});
      })
      .catch(error=>{
        console.log("Got error: "+JSON.stringify(error),error);
        alert("Error saving approach.");
      });
  }

  redirectToHomePage(event) {
    var type=this.props.project.isProduct ? "/products" : this.props.project.isProgramme ? "/programmes" : "/projects";
    window.location=type+"/"+this.props.project.id;
  }


  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div style={{paddingTop: 20, display:"flex", justifyContent:"center"}}>
        <div style={{width:1016, paddingBottom:30}}>
          <AreaForm
            {...this.props}
            areas={translations.createTranslatedForm(formDefinition,this.props.language,this.props.variant)}
            item={this.state.approach}
            display="tab"
            selected={this.state.selected}
            label={labels.general.approach}
            summary={this.summary.bind(this)}
            onUpdate={this.updateApproach.bind(this)}
            onCancel={this.redirectToHomePage.bind(this)}
          />
        </div>
      </div>
    )
  }
}

export default class PlanPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <ChangeControlApproach {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/change/Approach.jsx